<template>
    <section class="userSteps">
         <Header />
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-7">
                    <processing-message v-if="showDemoAccountProcessing"
                        message="Creating Demo account...">
                    </processing-message>
                    <div class="errorNotFound boxed mt-5 p-4 text-center" v-if="showTryAgain">
                        <span class="mb-3 mb-md-5 d-block">
                            <img width="450" src="/assets/images/404-Artwork.png" alt="page not found">
                        </span>
                        <p class="f-16" v-text="$t('changes.text9')"></p>
                        <a href="javascript:void(0)" @click.prevent="createDemoAccount()" class="button grd_btn">{{$t('subscript.text22')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
 import { useMainStore } from "@/store";
 import { useToast } from 'vue-toastification';
 import ProcessingMessage from '@/components/shared/ProcessingMessage.vue';
export default {
    setup() {
            const store = useMainStore();
            const toast = useToast();
            return { toast ,store}; 
        },
    data:function(){
        return {
            showDemoAccountProcessing:false,
            showTryAgain:false
        }
    },
    components: {
        ProcessingMessage
    },
    created:function(){
        this.createDemoAccount();
    },

    methods:{
        createDemoAccount:function(){
            let _that = this;
            try{
            let demo_account = false;
            _that.showTryAgain = false;
            _that.store.getUserAccountsList()
            .then(function(){
                if(_that.store?.userAccoutDetail?.accounts){
                    Object.keys(_that.store?.userAccoutDetail.accounts).forEach(function(acc){
                        if(_that.store?.userAccoutDetail.accounts[acc].demo == true){
                            demo_account = true; 
                        } 
                    });
                }
                if(demo_account == false){
                    _that.showDemoAccountProcessing = true;
                    setTimeout(function(){ 
                            _that.store.createDemoAccount()
                            .then(function(response){
                                _that.showDemoAccountProcessing = false;
                                if(response){
                                    _that.toast.success(_that.$t('changes.text10'));
                                    _that.refreshToken();
                                }
                                else{
                                    _that.toast.error(_that.$t('changes.text9'));
                                    _that.showTryAgain = true;
                                }
                            })
                         
                    },2000);
                }
                else{
                    _that.showDemoAccountProcessing = false;
                    _that.$router.replace('/complete-registration');
                }
            })
            .catch(function(){
                _that.showDemoAccountProcessing = false;
                _that.showTryAgain = true;
            });
           
        }
        catch(error){
            _that.showTryAgain = true;
            console.log("error",error.response);
        }   

        },

        refreshToken:function(){
            let _that = this;
            let form = {
                'grant_type' : 'refresh_token',
                'refresh_token' : this.store.user.refresh_token
            };
            this.store.refreshToken(form,false,'basic').then((response) =>{
                if(response.access_token){
                    // this.store.getUserAccountsList({},false)
                }
            })
            .then(function(){
                _that.$router.replace('/complete-registration');
            })
        },
    }
}
</script>

<style>

</style>